/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.04.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';

import ScrollArea from '../../../../ScrollArea';
import {VelocityComponent} from 'velocity-react';

import {StubFunc, getScroll, RDVR_STATES} from '../../../../../utils';
import {FetchAssetById} from '../../../../../actions/asset/action-asset';
import {SetPlayer, OpenMessage} from '../../../../../actions/common/actions-common';
import {SetSettingsState} from '../../../../../actions/common/actions-common';
import {GetMetadata} from '../../../../../actions/metadata/actions-metadata';
import {GetProgramGuideById, ClearScheduleStore} from '../../../../../actions/schedule/actions-schedule';
import {AddEventToSchedule, CancelRecoding} from '../../../../../actions/npvr/action-npvr';
import {AddToFavorites, RemoveFromFavorites} from '../../../../../actions/favorites/actions-favorites';
import {ACTIONS} from '../../../../../containers/Player';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';
import Share from '../../Widgets/Share';
import MultiscreenDevices from '../../Widgets/MultiscreenDevices';

import moment from 'moment';

import _at from 'lodash/at';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _some from 'lodash/some';
import _isNil from 'lodash/isNil';
import _isEqual from 'lodash/isEqual';
import _findLastIndex from 'lodash/findLastIndex';

class ChannelProfile extends Component {
  constructor(props) {
    super(props);

    this.FETCH_INTERVAL = 60 * 60 * 1000 + 4 * 1000;
    this.UPDATE_TIMEOUT = 60 * 1000;
    this.updateProgramGuideCollection = null;
    this.updateProgramGuideRender = null;

    this.calendar = ['before', 'previously', 'now', 'after', 'hereafter'];

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
      streamUrl: '',
      guideBlock: [],
      rdvrDevice: null,
      isPlayerShowed: false,
      streamCategory: null,
      showUserDevices: false
    };
  }

  componentWillMount() {
    let newState = {};
    this._fetchChannelAssetData(_get(this.props, 'channelId', null));

    if (this.props.channel.id) {

      lh.models.asset.methods
        .getPosterUrl(this.props.channel, {
          crop: {x: 100, y: 100},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`});
        });
    }

    let rdvrDevice = _find(this.props.rdvr_devices, {extid: 'x:npvr'});
    if (rdvrDevice) {
      newState.rdvrDevice = rdvrDevice;
    }

    this.updateProgramGuideCollection = setInterval(() => {
      // Will return when fixed from API
      //if (_get(this.props, 'channel.channel_type', null) === 'playlist') {
      //
      //  this.props.GetMetadata(this.props.channel.id);
      //}

      this.props.ClearScheduleStore([this.props.channelId], 'profile');
      this.props.GetProgramGuideById(this.props.channelId, {
        start: moment.utc().add(-12, 'hour').unix(),
        end: moment.utc().add(12, 'hour').unix()
      }, 'profile');
    }, this.FETCH_INTERVAL);

    this.setState(newState);
  }

  componentDidMount() {

    if (this.props.channel.id) {

      this.props.user.user !== 'guest' && !this._isNeedToPurchase() && !this.props.playerIsDetached && setTimeout(() => {

        this._startPlayback('live_hls');
      }, 750);
    }
  }

  componentWillReceiveProps(newProps) {
    let newState = {};

    if (this.props.channelId !== newProps.channelId) {
      this._stopPlayback();

      newState = {
        ...newState, ...{
          picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`,
          streamCategory: null,
          showUserDevices: false
        }
      };

      this.props.ClearScheduleStore([newProps.channelId], 'profile');
      this._fetchChannelAssetData(newProps.channelId);

      clearInterval(this.updateProgramGuideCollection);
      this.updateProgramGuideCollection = setInterval(() => {
        this.props.ClearScheduleStore([newProps.channelId], 'profile');
        this.props.GetProgramGuideById(newProps.channelId, {
          start: moment.utc().add(-12, 'hour').unix(),
          end: moment.utc().add(12, 'hour').unix()
        }, 'profile');
      }, this.FETCH_INTERVAL);
    }

    if (newProps.channel.id && newProps.channel.id !== this.props.channel.id) {
      newProps.user.user !== 'guest' && !this._isNeedToPurchase(newProps.channel) && !newProps.playerIsDetached && setTimeout(() => {
        this._startPlayback('live_hls');
      }, 350);

      lh.models.asset.methods
        .getPosterUrl(newProps.channel, {
          crop: {x: 100, y: 100},
          cache: false
        })
        .then((url) => {
          this.setState({picture: url});
        }, () => {
          this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/no-channel-logo.png`});
        });
    }

    if (_some(newProps.program_guide, _isNil)) {

      this.props.ClearScheduleStore([newProps.channelId], 'profile');
      this.props.GetProgramGuideById(newProps.channelId, {
        start: moment.utc().add(-12, 'hour').unix(),
        end: moment.utc().add(12, 'hour').unix()
      }, 'profile');
    }

    if (!_isEqual(this.props.program_guide, newProps.program_guide)) {
      this._prepareProgramGuide(newProps);
    }

    let isPlayerShowed = this.state.isPlayerShowed;
    if (newProps.playerIsDetached) {
      isPlayerShowed = false;

      newState = {
        ...newState, ...{
          isPlayerShowed: isPlayerShowed
        }
      };
    }

    let rdvrDevice = _find(newProps.rdvr_devices, {extid: 'x:npvr'});
    if (rdvrDevice) {
      newState = {
        ...newState, ...{
          rdvrDevice: rdvrDevice
        }
      };
    }

    //if (_get(newProps, 'channel.channel_type', null) === 'playlist' && isPlayerShowed && !_isEqual(this.props.metadata, newProps.metadata)) {
    //  this._prepareMetadataOverlay(newProps);
    //}

    this.setState(newState);
  }

  componentWillUnmount() {
    this.props.ClearScheduleStore([this.props.channelId], 'profile');

    this._stopPlayback();
    clearInterval(this.updateProgramGuideCollection);
    clearTimeout(this.updateProgramGuideRender);
  }

  _fetchChannelAssetData(channelId) {
    this.props.FetchAssetById(channelId);

    this.props.GetProgramGuideById(channelId, {
      start: moment.utc().add(-1, 'day').unix(),
      end: moment.utc().add(1, 'day').unix()
    }, 'profile');
  };

  //_prepareMetadataOverlay(prop = this.props) {
  //
  //  this.props.SetPlayer({
  //    action: ACTIONS.SET_METADATA,
  //    metadata: prop.metadata,
  //    type: 'clpp'
  //  });
  //}

  _prepareProgramGuide(props = this.props) {
    let now = moment().unix();

    let delayToUpdate = null;
    let showCatchup = _get(Config, 'channel_profile_epg', 'after_now') === 'before_now';

    let nowProgramIndex = _findLastIndex(_get(props, 'program_guide', []), (event) => {

      return event && event.start <= now && (event.start + event.duration) > now;
    });

    let guideBlockIndexs = [nowProgramIndex - 2, nowProgramIndex - 1, nowProgramIndex, nowProgramIndex + 1, nowProgramIndex + 2];

    let guideBlock = guideBlockIndexs.map((ind, index) => {
      let event = _get(props, 'program_guide[' + ind + ']', {id: null});

      event._date = event.start && moment.unix(event.start);
      event._dayName = this.calendar[index];

      return event
    });

    guideBlock = guideBlock.filter((event, index) => {
      return (event.is_catchup_available && showCatchup) || index >= 2;
    });

    let nowProgram = _get(props, 'program_guide[' + nowProgramIndex + ']', {id: null});

    if (nowProgram.start) {
      delayToUpdate = (nowProgram.start + nowProgram.duration - moment.utc().unix()) * 1000;

      clearTimeout(this.updateProgramGuideRender);
      this.updateProgramGuideRender = setTimeout(() => {
        this._prepareProgramGuide();

      }, delayToUpdate > 0 ? delayToUpdate : 60000);
    } else {

      clearTimeout(this.updateProgramGuideRender);
      this.updateProgramGuideRender = setTimeout(() => {
        this._prepareProgramGuide();

      }, this.UPDATE_TIMEOUT);
    }

    this.setState({
      guideBlock: guideBlock
    });
  }

  _hasContent() {

    return !!_find(this.props.channel.resources, (resource) => {

      return resource.type === 'stream' && resource.stream_type.indexOf('youtube') === -1 && !resource.category;
    });
  }

  _isRdvrAvailable() {
    var now = _find(this.state.guideBlock, {_dayName: 'now'}, {});

    return !!this.state.rdvrDevice && !!_find(_get(this.props.channel, 'resources', []), {category: 'npvr'}) && !!now && !now.is_fake;
  }

  _isNeedToPurchase(asset = this.props.channel) {

    return !asset.is_purchased && !asset.is_available && !asset.is_free;
  }

  _addToFavorites() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.AddToFavorites(this.props.channel.id);
  }

  _removeFromFavorites() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.RemoveFromFavorites(this.props.channel.id);
  }

  _addRecord(event) {

    if (this._isNeedToPurchase()) {
      this._showOffers();

      return;
    }

    if (this._isRdvrAvailable()) this.props.AddEventToSchedule(event.id, this.state.rdvrDevice);
  }

  _removeRecord(event) {
    if (this._isNeedToPurchase()) {
      this._showOffers();

      return;
    }

    if (this._isRdvrAvailable() && event.record) this.props.CancelRecoding(event.record.id);
  }

  _startPlayback(type) {

    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    if (!this.props.channel.is_purchased && !this.props.channel.is_available && !this.props.channel.is_free) {

      this._showOffers();
      return;
    }

    if (_get(this.props.user, 'data.is_blocked')) {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });

      return;
    }

    if (type === 'live_hls') {

      lh.models.viewAsset.methods.getStreamUrl(this.props.channel)
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'live_hls'});

          const programmeMonitoring = _find(this.state.guideBlock, {_dayName: 'now'}, {});
          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            vlive: _get(this.props, 'channel.channel_type', null) === 'playlist' ? _get(this.props, 'channel.id', null) : null,
            vlive_icon: this.state.picture,
            monitoring: {
              assetTitle: _get(this.props, 'channel.title'),
              assetID: _get(this.props, 'channel.id'),
              lcn: _get(this.props, 'channel.er_lcn') || _get(this.props, 'channel.lcn'),
              programID: _get(programmeMonitoring, 'id', 'null'),
              duration: _get(programmeMonitoring, 'duration', 'null'),
              type: 'channel'
            },
            get_url_again_fn: lh.models.viewAsset.methods.getStreamUrl.bind(this, this.props.channel)
          });
          //if (_get(this.props, 'channel.channel_type', null) === 'playlist') {
          //
          //  this._prepareMetadataOverlay();
          //}
        }, this._processStreamError);
    }
  }

  _stopPlayback() {

    this.setState({isPlayerShowed: false});
    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });
  }

  _toggleDevices(state) {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.setState({showUserDevices: state});
  };

  _closeProfile() {

    this._stopPlayback();
    this.props.onClose();
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: this.props.channel.id,
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  _processStreamError = (reason) => {
    if (_get(reason, 'message') === 'subscriber blocked') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });
    } else if (_get(reason, 'message') === 'the requested content is not available in your geographical location') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.GEO_BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'geo-blocker',
      });
    } else {
      //TODO: SHOW ERROR CODE
      console.log('Failed:', reason);
    }
  };

  _renderProgramGuide() {
    if (!this.state.guideBlock.length) {

      return [1, 2, 3].map((num, index) => {

        return <div className="block-1" key={'event_' + index}>
          <div className="profile-descr pr" style={{marginTop: (index !== 0) ? '30px' : '16px'}}>
            { (index === 0) && <div className="profile-title mb+"> { _get(this.props.channel, 'title', '') } </div> }
            { (index === 0) && <Translate content="epg.no_data" />}
          </div>
        </div>;
      });
    }

    return this.state.guideBlock.slice(0, 3).map((event, index) => {
      if (!event.id) {

        return (
          <div className="block-1" key={'event_' + index}>
            <div className="profile-descr pr" style={{marginTop: (index !== 0) ? '30px' : '16px'}}>
              { (index === 0) && <div className="profile-title mb+"> { _get(this.props.channel, 'title', '') } </div> }
              { (index === 0) && <Translate content="epg.no_data" /> }
            </div>
          </div>
        );
      }

      return (<div className="block-1" key={'event_' + index}>
        <div className="profile-descr pr" style={{marginTop: (index !== 0) ? '30px' : '16px'}}>
          { (index === 0) && <div className="profile-title"> { _get(this.props.channel, 'title', '') } </div> }
          <div className="color-grey" style={{paddingTop: '16px'}}>
            <Translate content={`profile.channel.calendar.${_get(event, '_dayName')}`} />
          </div>
          <div className="profile-bigtext">
            {!event.is_fake && event._date.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
          </div>
          <ScrollArea
            speed={0.8}
            className="profile-text"
            style={{height: '152px'}}
            horizontal={false}
            smoothScrolling={true}>
            <div>
              {!event.is_fake ? <div className="color-white"> {_get(event, 'program.title')} </div> : <Translate content="epg.no_data" /> }
              {_get(event, 'title') !== _get(event, 'program.title') && <div className="color-white"> {_get(event, 'title')} </div>}
              <div className="color-grey">{_get(event, 'description')}</div>
            </div>
          </ScrollArea>
        </div>
      </div>);
    });
  }

  _renderRecordButton() {
    let nowProgram = _find(this.state.guideBlock, {_dayName: 'now'}, {});

    if (!nowProgram.record) {

      return (<div className="mt-">
        <div className="color-grey pv-"><Translate content="profile.channel.record_add" /></div>
        <div>
          <a href="javascript:void(0)" className="hover" onClick={this._addRecord.bind(this, nowProgram)}>
            <i className="ic ic-record-add ic-24px"></i>
          </a>
        </div>
      </div>);
    } else {

      if ([RDVR_STATES.CANCELLED, RDVR_STATES.FAILED].indexOf(nowProgram.record.state) === -1) {
        if (RDVR_STATES.FINISHED !== nowProgram.record.state) {

          return (<div className="mt-">
            <div className="color-grey pv-"><Translate content="profile.channel.schedule_remove" /></div>
            <div>
              <a href="javascript:void(0)" className="hover" onClick={this._removeRecord.bind(this, nowProgram)}>
                <i className="ic ic-record-remove ic-24px"></i>
              </a>
            </div>
          </div>);
        } else {
          return (<div className="mt-">
            <div className="color-grey pv-"><Translate content="profile.channel.record_remove" /></div>
            <div>
              <a href="javascript:void(0)" className="hover" onClick={this._removeRecord.bind(this, nowProgram)}>
                <i className="ic ic-record-delete ic-24px"></i>
              </a>
            </div>
          </div>);
        }
      }
    }
  }

  render() {
    if (!_get(this.props, 'channel.id')) return <div className="profile channel-inf-example channel-inf-profile bg-black radius"><DivLoader loading={true} /></div>;

    return (<div className="profile channel-inf-example channel-inf-profile bg-black radius">
      <DivLoader loading={this.props.inProgress} />
      <VelocityComponent animation={{left: this.state.isPlayerShowed ? 0 : '-546px'}} duration={350}>
        <div className="channel-player block bg-black"></div>
      </VelocityComponent>
      <div className="profile-cols relative">
        <div className="channel-player-dummy relative ">
          <div className={"crow no-gutter" + (this._hasContent() ? " hover pointer" : "") + " player-dummy"} onClick={this._hasContent() && this._startPlayback.bind(this, 'live_hls')}
               style={{display: this.state.isPlayerShowed ? 'none' : 'block'}}>
            <img id="profile_channel_icon" className="profile-channel-icon" src={this.state.picture} alt="" />
            { this._isNeedToPurchase() ?
              <i className="ic ic-shopping-cart ic-32px"></i>
              :
              <img src={`/images/${Config.white_skin ? 'white' : 'black'}/play.png`} style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-30px', marginLeft: '-30px'}} />
            }
          </div>
        </div>
        {this._renderProgramGuide()}
        <div className="block-1">
          <div className="profile-r pr">
            <div className="profile-actions pr">
              <div className="mt-">
                <div className="color-grey pv-"><Translate content="profile.channel.epg" /></div>
                <div>
                  <Link to={'/epg/' + this.props.channel.id} className="hover">
                    <i className="ic ic-epg ic-24px"></i>
                  </Link>
                </div>
              </div>
              {this._isRdvrAvailable() && this._renderRecordButton()}
            </div>
          </div>
        </div>
        <div className="block-1 col-last">
          <div className="profile-r">
            <div className="profile-actions pr">
              {!this.props.channel.is_favorite ?
                <div className="mt-">
                  <div className="color-grey pv-"><Translate content="profile.channel.fav_add" /></div>
                  <div id="favorite"><a className="hover" onClick={this._addToFavorites.bind(this)}>
                    <i className="ic ic-fav-in ic-18px"></i>
                  </a></div>
                </div>
                :
                <div className="mt-">
                  <div className="color-grey pv-"><Translate content="profile.channel.fav_remove" /></div>
                  <div id="favorite"><a className="hover" onClick={this._removeFromFavorites.bind(this)}>
                    <i className="ic ic-fav-in-fill ic-18px"></i>
                  </a></div>
                </div>
              }
              {Config.multiscreen_allowed && this.props.user.user !== 'guest' &&
              <div className="mt-">
                <div className="color-grey pv-"><Translate content="profile.channel.multiscreen" /></div>
                <div id="screen">
                  <a className="hover share-to-device" onClick={this._toggleDevices.bind(this, true)}>
                    <i className="ic ic-multiscreen ic-24px"></i>
                  </a>
                </div>
              </div>
              }
              <div className="mt-">
                <Share contentUrl={`${location.origin}/asset/${this.props.channel.id}`} />
              </div>
            </div>
          </div>
          {Config.multiscreen_allowed && this.props.user.user !== 'guest' && <MultiscreenDevices asset={this.props.channel} show={this.state.showUserDevices} onClose={this._toggleDevices.bind(this, false)} />}
        </div>
      </div>
      <a className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
    </div>);
  }
}

ChannelProfile.propTypes = {
  channelId: PropTypes.number.isRequired,
  channel: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  inProgress: PropTypes.bool.isRequired
};

ChannelProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose Channel Profile')
};

const mapStateToProps = function ({assets, auth: {user}, schedule, metadata, common: {devices: {rdvr_devices}, player}}, ownProps) {
  let asset = _get(assets, _get(ownProps, 'channelId', null), {});

  let scheduleForProfile = _get(_get(schedule, 'scheduleForProfile', {}), _get(ownProps, 'channelId', null));
  scheduleForProfile = _at(_get(schedule, 'eventForProfile', {}), _get(scheduleForProfile, 'schedule', []));

  return {
    user: user,
    channel: asset,
    inProgress: !!asset._fetchInProgress,
    program_guide: scheduleForProfile,
    rdvr_devices: rdvr_devices,
    playerIsDetached: !!player.isDetached
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({
    FetchAssetById,
    SetPlayer,
    OpenMessage,
    SetSettingsState,
    ClearScheduleStore,
    GetProgramGuideById,
    GetMetadata,
    AddEventToSchedule,
    CancelRecoding,
    AddToFavorites,
    RemoveFromFavorites
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/Channel/channel-profile.js